module.exports = __webpack_public_path__ + "img/icons8-services-100.def0dc7d.svg";